import { useQuery } from '@tanstack/react-query';
import { clsx } from 'clsx';
import { Link } from 'react-router-dom';
import { agencyApi } from '../../api/agencyApi';
import { agencyKeys } from '../../queryKeys';
import styles from './ModulesTab.module.css';

const LABEL = {
  not_started: 'Texts: not set up',
  setup: 'Texts: setup',
  awaiting_registration: 'Texts: awaiting registration',
  live: 'Texts: live',
  paused: 'Texts: paused',
} as const;

/** The text review program's status for one location (PRD 5 §4.7 step 5), shown when the flag is on. */
export function ReviewSmsStatusPill({
  practiceId,
  locationId,
}: {
  practiceId: string;
  locationId: string;
}) {
  const { data } = useQuery({
    queryKey: agencyKeys.reviewSmsStatus(practiceId, locationId),
    queryFn: () => agencyApi.getReviewSmsStatus(practiceId, locationId),
    staleTime: 60_000,
  });
  if (!data) return null;
  // Switched on but nothing can text yet: say what is blocking, and link to where it gets fixed.
  const blocked =
    data.status !== 'not_started' && data.texting && data.texting !== 'ready' ? data.texting : null;
  if (blocked) {
    return (
      <Link
        to={`?tab=settings&section=texting&location=${encodeURIComponent(locationId)}`}
        className={clsx(styles.pill, styles.pillOff)}
      >
        {blocked === 'setup'
          ? 'Texts: waiting on texting number'
          : 'Texts: waiting on carrier registration'}
        {' · Settings → Communication → Texting'}
      </Link>
    );
  }
  return (
    <span className={clsx(styles.pill, data.status === 'live' ? styles.pillOn : styles.pillOff)}>
      {LABEL[data.status]}
      {data.test.enabled ? ` · test mode (${data.test.phoneMasked ?? ''})` : ''}
    </span>
  );
}
